import type { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';
import type { Client } from '@core/api/utils';
import { getSignedInUserId } from '@core/auth/redux';
import { fetchSubscriptions } from '../api/subscriptions';
import type { loadSubscriptions as loadSubscriptionsAction } from '../redux/subscriptions';
import {
  loadSubscriptionsSuccess,
  loadSubscriptionsFailure,
} from '../redux/subscriptions';

const loadSubscriptions = function* (
  client: Client,
  action: ReturnType<typeof loadSubscriptionsAction>,
): SagaIterator {
  try {
    const userId = yield select(getSignedInUserId);
    const subs = yield call(fetchSubscriptions, client, userId);
    yield put(loadSubscriptionsSuccess(subs, action.payload.id));
  } catch (e) {
    yield put(loadSubscriptionsFailure(action.payload.id));
  }
};

export default loadSubscriptions;
